import script from "./xt_article_card_brief.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_article_card_brief.vue?vue&type=script&setup=true&lang=js"

import "./xt_article_card_brief.vue?vue&type=style&index=0&id=c93835a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c93835a6"]])

export default __exports__